<template>
  <div class="page-case-edit">
    <el-form :model="form" :rules="rules" ref="form" status-icon label-width="100px">
      <app-page-box title="基础信息">
        <div class="page-case-edit__form-wrap">
          <el-form-item label="案例名称" prop="name" size="small">
            <el-input type="text" v-model="form.name" placeholder="请输入案例名称"></el-input>
          </el-form-item>
          <el-form-item label="排序位置" prop="position" size="small">
            <el-input-number v-model="form.index" controls-position="right" :min="1" :max="100"></el-input-number>
          </el-form-item>
        </div>
      </app-page-box>
      <app-page-box title="图片信息">
        <el-form-item label="上传图片" prop="imageList" size="small">
          <div class="page-product-edit__img">
            <app-image-uploader :images="images" @change="handleImagesChange"></app-image-uploader>
          </div>
          <p class="page-case-edit__tip">建议图片尺寸500px * 350px，格式为.png、.jpg以及.jpeg，大小1M以下，最多可以上传4张</p>
        </el-form-item>
      </app-page-box>
      <app-page-box title="描述信息" tip="案例描述尽量用图文排版布局，有利于快速排名">
        <el-form-item label="案例描述" prop="description" size="small">
          <sme-editor v-model="form.description" @input="handleEditorInput" placeholder="请输入案例描述"></sme-editor>
        </el-form-item>
        <el-form-item class="page-case-edit__submit" size="small">
          <el-button @click="handleBtnCancelClick">取消</el-button>
          <el-button type="primary" @click="handleOkBtnClick">确认发布</el-button>
        </el-form-item>
      </app-page-box>
    </el-form>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'
import AppImageUploader from '@/components/AppImageUploader'

export default {
  name: 'page-case-edit',
  components: {
    AppPageBox,
    AppImageUploader
  },

  data () {
    return {
      form: {
        id: undefined,
        name: '',
        index: 1,
        imageList: [],
        description: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入案例名称', trigger: 'change' },
          { min: 2, max: 20, message: '案例名称：2-20字', trigger: 'change' }
        ],
        imageList: { type: 'array', required: true, message: '请上传案例图片', trigger: 'manual' },
        description: [
          { required: true, message: '请输入案例描述', trigger: 'input' },
          { min: 10, max: 5000, message: '案例名称：10-5000字', trigger: 'input' }
        ]
      }
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },

    images () {
      const { showImage } = this.$options.filters
      return this.form.imageList.map((item, index) => {
        return {
          name: `pic-${index}`,
          url: showImage(item),
          response: { file_id: item }
        }
      })
    }
  },

  created () {
    this.getCurrentCase()
  },

  methods: {
    getCurrentCase () {
      const caseId = this.$route.query.id

      if (!caseId) return

      this.$store.dispatch('getCaseById', {
        params: {
          userId: this.user.id,
          caseId: caseId
        }
      }).then(response => {
        const { productCase } = response.data

        this.form.id = productCase.id
        this.form.name = productCase.name
        this.form.index = productCase.index
        this.form.imageList = productCase.imageList
        this.form.description = productCase.description
      })
    },

    createCase () {
      this.$store.dispatch('createCase', {
        params: { userId: this.user.id },
        body: {
          productCase: {
            name: this.form.name,
            index: this.form.index,
            imageList: this.form.imageList.filter(item => !!item),
            description: this.form.description,
            status: 0
          }
        }
      }).then(response => {
        this.$router.push({ name: 'CaseList' })
      }).catch(() => {
        // No handler
      })
    },

    updateCase () {
      this.$store.dispatch('updateCase', {
        params: {
          userId: this.user.id,
          caseId: this.form.id
        },
        body: {
          productCase: {
            name: this.form.name,
            index: this.form.index,
            imageList: this.form.imageList,
            description: this.form.description
          }
        }
      }).then(response => {
        this.$router.push({ name: 'CaseList' })
      }).catch(() => {
        // No handler
      })
    },

    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.updateCase()
          } else {
            this.createCase()
          }
        }
      })
    },

    handleImagesChange (imageIds) {
      this.form.imageList = imageIds
      this.$refs.form.validateField('imageList')
    },

    handleEditorInput () {
      this.$refs.form.validateField('description')
    },

    handleBtnCancelClick () {
      this.$router.push({ name: 'CaseList' })
    },

    handleOkBtnClick () {
      this.submit()
    }

  }
}
</script>

<style lang="scss">
.page-case-edit {
  min-height: 100%;
  background-color: #fff;

  .el-form-item.is-required .el-form-item__label:before {
    font-family: sans-serif;
  }

  .app-page-box {
    margin-bottom: 0;
  }

  .el-dialog__body {
    padding: 10px 20px 20px;
  }

  &__form-wrap {
    width: 500px;
  }

  &__img {
    display: flex;
    justify-content: space-between;
  }

  &__tip {
    margin: 0;
    color: #999;
    font-size: 12px;
  }

  &__category {
    display: flex;

    .el-select {
      flex: 1;
    }

    .el-button {
      margin-left: 10px;
    }
  }

  &__submit {
    margin-top: 30px;
  }

}
</style>
